import { createAuthClient } from "better-auth/react";

/** Client Better Auth : même origine (proxy Vite en dev, API en prod). */
export const authClient = createAuthClient({ baseURL: window.location.origin, basePath: "/api/auth" });
